import { useState, useEffect, useRef } from "react";
import Bold from "../style/styleBold";
import { useParams, Link } from "react-router-dom";
import "./PageAdminIndividual.css";
import WelcomeAdmin from "./welcomeAdmin";
import { useUser } from "../userContext";
import baseUrl from "../baseUrl";

const PageAdminIndividualHighSchool = () => {
  const { id } = useParams();
  const [currentApplicant, setCurrentApplicant] = useState();
  const { currentUser } = useUser();
  const downloadLinkRef = useRef(null);

  useEffect(() => {
    console.log("INDIVIDUAL HIGH SCHOOL");
    const fetchApplicant = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/high-school/get-individual/${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          },
        );

        if (response.ok) {
          console.log("An applicant fetched.");
          const data = await response.json();
          setCurrentApplicant(data);
          window.scrollTo(0, 0);
        } else {
          console.error("Applicant not fetched.");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchApplicant();
  }, []);

  const downloadPDF = async (applicantId) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/high-school/download-pdf/${applicantId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // Update the href of the <a> element dynamically
        if (downloadLinkRef.current) {
          downloadLinkRef.current.href = url;
          downloadLinkRef.current.download = `${currentApplicant.firstName}_${currentApplicant.lastName}_Application_Package.pdf`;

          // Programmatically trigger the click event to start the download
          downloadLinkRef.current.click();
        }
      } else {
        console.error("Failed to download PDF");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const downloadFile = async (applicantId, fileId, fileName) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/high-school/download-file/${applicantId}/${fileId}`,
        {
          method: "GET",
          credentials: "include",
        },
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${currentApplicant.lastName}_${fileName}.pdf`;
        a.click();

        window.URL.revokeObjectURL(url);
      } else {
        console.error("Failed to download file:", await response.json());
      }
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  return (
    <>
      <div className="individual-applicant-page">
        <table>
          <tbody>
            {currentApplicant && (
              <>
                <tr>
                  <td className="name">
                    <Bold>Name: </Bold>
                  </td>
                  <td className="name">
                    <Bold>
                      {" "}
                      {currentApplicant.firstName} {currentApplicant.lastName}
                    </Bold>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Bold>Date of Birth: </Bold>
                  </td>
                  <td>
                    {new Date(currentApplicant.dateOfBirth).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      },
                    )}
                  </td>
                </tr>

                {currentApplicant.socialSecurity && (
                  <tr>
                    <td>
                      <Bold>Social Security Number: </Bold>
                    </td>
                    <td>{currentApplicant.socialSecurity}</td>
                  </tr>
                )}
                {currentApplicant.phone && (
                  <tr>
                    <td>
                      <Bold>Phone: </Bold>
                    </td>
                    <td>{currentApplicant.phone}</td>
                  </tr>
                )}
                {currentApplicant.email && (
                  <tr>
                    <td>
                      <Bold>Email: </Bold>
                    </td>
                    <td>{currentApplicant.email}</td>
                  </tr>
                )}
                {currentApplicant.address && (
                  <tr>
                    <td>
                      <Bold>Address: </Bold>
                    </td>
                    <td>{currentApplicant.address}</td>
                  </tr>
                )}
                <tr>
                  <td>
                    <Bold>High School Attended: </Bold>
                  </td>
                  <td>{currentApplicant.highSchoolAttended}</td>
                </tr>
                <tr>
                  <td>
                    <Bold>Year Graduated: </Bold>
                  </td>
                  <td>{currentApplicant.yearGraduated}</td>
                </tr>
                <tr>
                  <td>
                    <Bold>Citizenship: </Bold>
                  </td>
                  <td>{currentApplicant.citizenship}</td>
                </tr>
                <tr>
                  <td>
                    <Bold>CollegeAccepted: </Bold>
                  </td>
                  <td>{currentApplicant.collegeAccepted}</td>
                </tr>
                {currentApplicant.files &&
                  currentApplicant.files.map((file, index) => (
                    <tr key={index}>
                      <td>
                        <Bold>{file.fileAlias}: </Bold>
                      </td>
                      <td>
                        <Link
                          onClick={() =>
                            downloadFile(
                              currentApplicant.school_applicant_id,
                              file.fileID,
                              file.fileAlias,
                            )
                          }
                        >
                          Download
                        </Link>
                      </td>
                    </tr>
                  ))}

                <tr>
                  <td>
                    <Bold>Comments: </Bold>
                  </td>
                  <td>{currentApplicant.comments}</td>
                </tr>

                {(currentUser.role === "admin" ||
                  currentUser.role === "employee") && (
                  <tr>
                    <td className="pdf-download" colSpan="2">
                      <button
                        onClick={() =>
                          downloadPDF(currentApplicant.school_applicant_id)
                        }
                      >
                        DOWNLOAD
                      </button>
                      {downloadLinkRef && (
                        <a ref={downloadLinkRef} style={{ display: "none" }}>
                          Open PDF
                        </a>
                      )}
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PageAdminIndividualHighSchool;
